export default {
  activeBrand: null,
  brands: [],
  theme: undefined,
}
